import React from 'react';
import { connect } from 'react-redux'

import { _setAxios, _success, _tableLogActivity, getParamTable, _validationFormMsg } from '../../lib/Helper';
import { schemaPesantren } from './schema';
import validate from 'validate.js';
import { riwayatPesantrenKosentrasiOptions } from '../../data/options';

import { Table, Row, Col, Divider, Popover, Button, Radio, Space, Dropdown, Input, Tooltip, Modal } from 'antd';
import { PageHeader } from 'components/header';
import { SaveOutlined, InfoCircleOutlined, SearchOutlined, EllipsisOutlined, PlusOutlined, SortAscendingOutlined, EditOutlined, DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import Stack from '@mui/material/Stack';

const tableOptions = {
    sorts: [{
        value: "ASC",
        label: "Ascending",
    }, {
        value: "DESC",
        label: "Descending",
    }],
    fields: [{
        value: "id",
        label: "Tanggal Pembuatan",
    }, {
        value: "nama",
        label: "Nama",
    }]
}

class RiwayatPesantren extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            values: {},
            errors: {},

            table: {
                loading: false,
                data: [],
                search: "",
                pagination: {
                    current: 1,
                    pageSize: 10,
                    total: 0,
                },
                sorting: [],
                filtering: {},
            },
            form: {
                visible: false,
                loading: false,
            },
            fileList: [],
            validateFile: false
        };
    }

    componentDidMount() {
        this.fetchTable()
    }

    fetchTable = () => {
        const { table } = this.state
        const params = getParamTable("default", table)
        this.fetch(params);
    }

    fetch = async (params = {}) => {
        this.setState({
            table: {
                ...params,
                loading: true
            }
        });
        _setAxios("tk/pesantren/table/" + this.props.dataID, "POST", params).then(resp => {
            if (resp.status === true) {
                this.setState({
                    table: {
                        ...params,
                        loading: false,
                        data: resp.data.list,
                        pagination: {
                            ...params.pagination,
                            total: resp.data.info.total
                        }
                    }
                });
            } else {
                this.setState({
                    table: {
                        ...params,
                        loading: false,
                    }
                })
            }
        })
    };

    handleChange = (e) => {
        const { values } = this.state;
        const { name, value } = e.target;

        this.setForm(values, name, value)
    };

    handleChangeSetValue = (name, value) => {
        const { values } = this.state;
        this.setForm(values, name, value)
    };

    setForm = (values, name, value) => {
        values[name] = value;

        const errors = validate(values, schemaPesantren);
        this.setState({
            values: values,
            errors: errors || {},
        });

        return this.setValidate(values)
    }

    setValidate = (values) => {
        const errors = validate(values, schemaPesantren);
        this.setState({
            values: values,
            errors: errors || {},
        });

        return errors
    }

    hasError = field => {
        return this.state.errors[field] ? true : false;
    }

    // CREATE START ------------------------------------------
    hideModalForm = (row) => {
        this.setState({
            form: {
                ...this.state.form,
                visible: false
            },
            values: {},
            errors: {},
        });
    };

    showModalForm = (row) => {
        if (row.id) {
            this.setState({
                form: {
                    ...this.state.form,
                    visible: true,
                },

                values: {
                    id: row.id ? row.id : null,
                    konsentrasi: row.konsentrasi ? row.konsentrasi : null,
                    lama_pendidikan: row.lama_pendidikan ? row.lama_pendidikan : null,
                    tgl_mulai: row.tgl_mulai ? row.tgl_mulai : null,
                    tgl_lulus: row.tgl_lulus ? row.tgl_lulus : null,
                },
            });
        } else {
            this.setState({
                form: {
                    ...this.state.form,
                    visible: true,
                },
            });
        }
    };

    onSubmitForm = async (e) => {
        e.preventDefault();
        const { values } = this.state

        //Validation 
        let validation = this.setValidate(values, schemaPesantren)
        if (validation !== undefined) {
            return _validationFormMsg(validation)
        }

        // Tahun & Tanggal
        let tglMulai = values.tgl_mulai
        if (values.tgl_mulai && values.tgl_mulai instanceof Date) {
            let tgl = values.tgl_mulai.getDate() <= 9 ? "0" + values.tgl_mulai.getDate() : values.tgl_mulai.getDate()
            let bln = values.tgl_mulai.getMonth() <= 9 ? "0" + values.tgl_mulai.getMonth() : values.tgl_mulai.getMonth()
            let thn = values.tgl_mulai.getFullYear()

            tglMulai = tgl + "-" + bln + "-" + thn
        }
        let tglLulus = values.tgl_lulus
        if (values.tgl_lulus && values.tgl_lulus instanceof Date) {
            let tgl = values.tgl_lulus.getDate() <= 9 ? "0" + values.tgl_lulus.getDate() : values.tgl_lulus.getDate()
            let bln = values.tgl_lulus.getMonth() <= 9 ? "0" + values.tgl_lulus.getMonth() : values.tgl_lulus.getMonth()
            let thn = values.tgl_lulus.getFullYear()

            tglLulus = tgl + "-" + bln + "-" + thn
        }

        // Payload
        const param = {
            konsentrasi: values.konsentrasi ? values.konsentrasi : null,
            lama_pendidikan: values.lama_pendidikan ? values.lama_pendidikan : null,
            tgl_mulai: tglMulai,
            tgl_lulus: tglLulus,
        }

        // Define Network
        let method = "POST"
        let payload = [param]
        let id = this.props.dataID
        if (values.id) {
            method = "PUT"
            payload = param
            id = values.id
        }

        this.setState({
            form: {
                ...this.state.form,
                loading: true
            }
        });
        _setAxios("tk/pesantren/" + id, method, payload).then(resp => {
            if (resp.status === true) {
                _success('topRight', 'Success', resp.data.message)
                this.hideModalForm()
                this.fetchTable()
            }

            this.setState({
                form: {
                    ...this.state.form,
                    loading: false
                }
            });
        })
    };

    // CREATE END ------------------------------------------


    onDelete = (row) => {
        Modal.confirm({
            title: 'Hapus Data',
            width: 470,
            icon: <ExclamationCircleOutlined />,
            content: <>Data akan dihapus dari list, Apakah Anda Yakin ?</>,
            cancelText: 'Batal',
            okText: 'Simpan',
            onOk: () => {
                return new Promise((resolve, reject) => {
                    _setAxios("tk/pesantren/" + row.id, "DELETE").then(resp => {
                        if (resp.status === true) {
                            _success('topRight', 'Success', resp.data.message)
                            this.fetchTable()
                        }
                        setTimeout(Math.random() > 0.5 ? resolve : reject, 100);
                    })
                }).catch(() => console.log('Oops errors!'));
            },
            onCancel: () => {
                console.log("No action to process")
            },
        });
    }

    render() {
        const { table, values, errors } = this.state;

        const sortComponent = <>
            <Radio.Group onChange={(e) => {
                const params = getParamTable("sort_field", table, e.target.value)
                this.fetch(params)
            }} value={table.sorting.length > 0 ? table.sorting[0].field : ""} name="sort_field">
                <Space direction="vertical">
                    {tableOptions.fields.map((row, i) => <Radio key={i} value={row.value}>{row.label}</Radio>)}
                </Space>
            </Radio.Group>
            <Divider orientation="left"></Divider>
            <Radio.Group onChange={(e) => {
                const params = getParamTable("sort", table, e.target.value)
                this.fetch(params)
            }} value={table.sorting.length > 0 ? table.sorting[0].sort : ""} name="sort_value">
                <Space direction="vertical">
                    {tableOptions.sorts.map((row, i) => <Radio key={i} value={row.value}>{row.label}</Radio>)}
                </Space>
            </Radio.Group>
        </>

        const modalForm = <Modal
            title="Form Riwayat Pesantren"
            open={this.state.form.visible}
            // width={700}
            onCancel={this.hideModalForm}
            footer={<>
                <Button onClick={this.hideModalForm}>Batal</Button>
                <Button type="primary" htmlType="submit" onClick={this.onSubmitForm} loading={this.state.form.loading} icon={<SaveOutlined />}>Simpan</Button>
            </>}
        >
            <Row gutter={[16, 16]}>
                <Col xs={24}>
                    <Autocomplete
                        options={riwayatPesantrenKosentrasiOptions}
                        renderInput={(params) => <TextField {...params}
                            fullWidth
                            label="Terkhusus/Konsentrasi"
                            size="small"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            name="konsentrasi"
                            type="text"
                            error={this.hasError('konsentrasi')}
                            helperText={
                                this.hasError('konsentrasi') ? errors.konsentrasi[0] : null
                            }
                        />}
                        value={values.konsentrasi || null}
                        onChange={(e, newValue) => {
                            this.handleChangeSetValue("konsentrasi", newValue ? newValue.value : null)
                        }}
                    />
                </Col>
                <Col xs={24}>
                    <TextField
                        fullWidth
                        label="Lama Pendidikan (Tahun)"
                        size="small"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        name="lama_pendidikan"
                        type="text"
                        onChange={this.handleChange}
                        value={values.lama_pendidikan || ''}
                        error={this.hasError('lama_pendidikan')}
                        helperText={
                            this.hasError('lama_pendidikan') ? errors.lama_pendidikan[0] : null
                        }
                    />
                </Col>
                <Col xs={24} sm={12}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Stack spacing={3}>
                            <MobileDatePicker
                                label="Tanggal Mulai"
                                value={values.tgl_mulai || null}
                                onChange={(newValue) => {
                                    this.handleChangeSetValue("tgl_mulai", newValue)
                                }}
                                renderInput={(params) => <TextField
                                    size="small"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    error={this.hasError('tgl_mulai')}
                                    helperText={
                                        this.hasError('tgl_mulai') ? errors.tgl_mulai[0] : null
                                    }
                                    {...params} />}
                            />
                        </Stack>
                    </LocalizationProvider>
                </Col>
                <Col xs={24} sm={12}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Stack spacing={3}>
                            <MobileDatePicker
                                label="Tanggal Lulus"
                                value={values.tgl_lulus || null}
                                onChange={(newValue) => {
                                    this.handleChangeSetValue("tgl_lulus", newValue)
                                }}
                                renderInput={(params) => <TextField
                                    size="small"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    error={this.hasError('tgl_lulus')}
                                    helperText={
                                        this.hasError('tgl_lulus') ? errors.tgl_lulus[0] : null
                                    }
                                    {...params} />}
                            />
                        </Stack>
                    </LocalizationProvider>
                </Col>
            </Row>
        </Modal>

        return (
            <>
                <PageHeader
                    className="site-page-header"
                    title="Riwayat Pesantren"
                    extra={
                        <>
                            {/* <Button type="text"><Link to={`/tenaga-kependidikan/guru`}>Kembali</Link></Button> */}
                            <Tooltip title="Tambah">
                                <Button type='primary' icon={<PlusOutlined />} onClick={this.showModalForm}> Tambah</Button>
                            </Tooltip>
                        </>
                    }
                />
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={21}>
                        <Input
                            name="search"
                            className='search-table'
                            placeholder="Search..."
                            prefix={<SearchOutlined className="site-form-item-icon" />}
                            onChange={(e) => {
                                const params = getParamTable("search", table, e.target.value)
                                this.fetch(params)
                            }}
                            value={table.search || ""}
                            suffix={
                                <Tooltip title="Cari berdasarkan nama">
                                    <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                </Tooltip>
                            }
                        />
                    </Col>
                    <Col xs={24} sm={3}>
                        <Button.Group className='ant-btn-group-fullwidth'>
                            <Popover placement="bottom" content={sortComponent} trigger="click">
                                <Button block className='btn-border-radius-right'><SortAscendingOutlined /> Sort</Button>
                            </Popover>
                        </Button.Group>
                    </Col>

                </Row>

                <Divider orientation="left"></Divider>

                <Row>
                    <Col span={24}>
                        <Table
                            columns={[
                                {
                                    title: 'No',
                                    dataIndex: 'rownum',
                                    width: '3%',
                                },
                                {
                                    title: 'Terkhusus/Konsentrasi',
                                    dataIndex: 'konsentrasi',
                                },
                                {
                                    title: 'Lama Pendidikan (Tahun)',
                                    dataIndex: 'lama_pendidikan',
                                    width: '15%',
                                },
                                {
                                    title: 'Tanggal Mulai',
                                    dataIndex: 'tgl_mulai',
                                },
                                {
                                    title: 'Tanggal Lulus',
                                    dataIndex: 'tgl_lulus',
                                },
                                {
                                    title: <EllipsisOutlined />,
                                    align: "center",
                                    key: 'operation',
                                    width: '2%',
                                    render: (a, row) => <Dropdown trigger={['click']} menu={{
  items: [{
    key: 0,
    icon: <EditOutlined />,
    label: "Update",
    onClick: this.showModalForm.bind(this, row)
  }, {
    key: 1,
    icon: <DeleteOutlined />,
    label: "Delete",
    onClick: this.onDelete.bind(this, row)
  }]
}}>
                                        <div className="ant-dropdown-link tb-action">
                                            <Button type='primary'>Opsi</Button>
                                        </div>
                                    </Dropdown>,
                                },
                                {
                                    title: 'LogActivity',
                                    key: 'operation',
                                    width: '10%',
                                    render: (a, row) => _tableLogActivity(row),
                                },
                            ]}
                            rowKey={record => record.id}
                            dataSource={table.data}
                            pagination={table.pagination}
                            loading={table.loading}
                            onChange={(pagination) => {
                                const params = getParamTable("change", table, null, null, pagination)
                                this.fetch(params)
                            }}
                            size="small"
                        />
                    </Col>
                </Row>

                {modalForm}
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        privilege: state.privilege,
    }
}

export default connect(mapStateToProps)(RiwayatPesantren);
